var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['title']},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("subtitle",[_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }